import { useState } from 'react';

import { TagDTO } from '@gearbelt/global';
import { Button } from '@gearbelt/ui/components';

import PencilIcon from '@/components/icons/pencil';
import { Badge } from '@/components/ui/badge';

import { UpdateWorkspaceScheduleTags } from './update-workspace-schedule-tags';

function ScheduleCheckTags({
  onTagsChange,
  scheduleTags,
  disabled = false,
}: {
  onTagsChange: (tags: TagDTO[]) => void;
  scheduleTags: TagDTO[] | undefined;
  disabled?: boolean;
}) {
  const [openScheduleTagsUpdate, setOpenScheduleTagsUpdate] = useState(false);

  return (
    <div className="flex w-full items-start gap-4">
      <p className="text-default-text w-[350px] shrink-0 text-sm">Schedule Check tags</p>
      <div className="flex min-w-px flex-1 flex-col gap-2">
        {scheduleTags && scheduleTags.length > 0 ? (
          <div className="flex flex-wrap gap-1">
            {scheduleTags.map((scheduleTag) => (
              <Badge key={scheduleTag.id} size="sm" variant="violet">
                {scheduleTag.tag}
              </Badge>
            ))}
          </div>
        ) : (
          <div className="text-secondary-text text-sm">No Schedule Check tags have been created yet.</div>
        )}
        {!disabled && (
          <Button
            variant="ghost"
            type="button"
            icon={<PencilIcon />}
            className="bg-grey-1 hover:bg-grey-3 w-fit"
            onClick={() => {
              setOpenScheduleTagsUpdate(true);
            }}>
            Edit Tags
          </Button>
        )}
      </div>

      <UpdateWorkspaceScheduleTags scheduleTags={scheduleTags} open={openScheduleTagsUpdate} onOpenChange={setOpenScheduleTagsUpdate} callback={onTagsChange} />
    </div>
  );
}

export default ScheduleCheckTags;
